import posthog from "./posthog";

// Analytics must never break a business handler.
export function track(event, properties = {}) {
  try {
    posthog.capture(event, properties);
  } catch (e) {
    if (process.env.NODE_ENV !== "production") console.warn("[analytics]", e);
  }
}
